<template>
  <div class="price-table-container">
    <div class="table-header">
      <div class="row">
        <div class="col-metal">
          <select class="weight" v-model="weightUnit">
            <option v-for="unit in weightUnits" :key="unit" :value="unit">
              {{ $t('message.' + unit) }}
            </option>
          </select>
        </div>
        <div class="col-time">{{ $t('message.time') }}</div>
        <div class="col-price">
          <div class="currency">
            <select v-model="currency">
              <option v-for="(rate, symbol) in currencies" :key="symbol" :value="symbol">
                {{ symbol }}
              </option>
            </select>
          </div>
          <div class="row">
            <div class="col-half">{{ $t('message.buy') }}</div>
            <div class="col-half">{{ $t('message.sell') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-body">
      <div class="row" v-for="metal in metals" :key="metal.metal">
        <div class="col-metal">
          <div class="name">
            {{ $t('message.' + metal.metal.toLowerCase()) }}
          </div>
          <div class="change" v-bind:class="{ negative: metal.percentChange < 0 }">
            {{(metal.percentChange.toFixed(2)) | evolution}}%
          </div>
        </div>
        <div class="col-time">
          {{ metal.time }}
          </div>
        <div class="col-bid">
            {{ (metal.bidRate[weightUnit] * currencies[currency]).toFixed(0) | formatNumber }}
        </div>
        <div class="col-ask">
          {{ (metal.askRate[weightUnit] * currencies[currency]).toFixed(0) | formatNumber}}
          </div>
      </div>

    </div>

  <a :href="'tel:'+$t('message.phone')" class="contact row">
    <div class="label">Contact</div>
    <div class="number">
      <img src="../assets/phone.png">
      <span>{{$t('message.phone_label')}}</span>
    </div>
  </a>

  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'hello',
  data: function () {
    return {
      msg: 'Welcome to Your Vue.js PWA',
      weightUnits: ['ounce', 'gram', 'kilogram'],
      weightUnit: 'kilogram',
      currencies: {'USD': 1},
      currency: 'USD',
      metals: api.getCachedMetals()
    }
  },
  created: async function () {
    this.metals = await api.getMetals()
    this.currencies = await api.getCurrencies(['EUR', 'USD', 'PLN'])
    setInterval(this.refreshMetals, 3000)
    setInterval(this.refreshCurrencies, 3000)
  },
  methods: {
    refreshMetals: async function () {
      this.metals = await api.getMetals()
    },
    refreshCurrencies: async function () {
      this.currencies = await api.getCurrencies(['EUR', 'USD', 'PLN'])
    }
  }
}
</script>

<style>
.row {
  display: flex;
}

.table-header .row > div {
  border-right: 1px solid rgba(255, 255, 255, 0.5);
}

.table-body .row > div {
  border-right: 1px solid rgba(255, 255, 255, 0.5);
}

.row > div:last-child {
  border-right: 0;
}

.table-header {
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  line-height: 5rem;
}

.table-header .currency {
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.table-header .col-metal {
  width: 35%;
  text-transform: uppercase;
}
.table-header .col-time {
  width: 15%;
  text-transform: uppercase;
}
.table-header .col-price {
  width: 50%;
  line-height: 2.5rem;
}
.table-header .col-bid {
  width: 25%;
}
.table-header .col-ask {
  width: 25%;
}
.table-header .col-half {
  width: 50%;
}

.table-body .row {
  line-height: 4rem;
  border: 1px solid rgba(180, 180, 180, 0.5);
  border-radius: 20px;
  width: 90%;
  margin: auto;
  margin-top: 2rem;
  background-color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
}

.table-body .row:nth-child(2n) {
  background-color: rgba(200, 120, 49, 0.5);
}

.table-body .col-metal {
  flex: 3333;
}

.table-body .col-metal .name {
  font-size: 1.2rem;
  font-weight: bold;
}

.table-body .col-metal .change {
  margin-top: -1rem;
  line-height: 0.9rem;
  font-size: 0.9rem;
  text-align: right;
  padding-right: 1rem;
  color: green;
}

.table-body .col-metal .change.negative {
  color: red;
}

.table-body .col-time {
  flex: 1667;
  font-size: 0.9rem;
}

.table-body .col-bid {
  flex: 2778;
}

.table-body .col-ask {
  flex: 2222;
}

.table-body .col-bid, .table-body .col-ask {
  font-weight: bold;
}

select {
  background: url('../assets/select-arrow.png') no-repeat right transparent;
  background-size: auto 1.2rem;
  padding-right: 2rem;
  color: white;
  font-size: 1rem;
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  outline: none;
  font-weight: bold;
  text-align: center;
  height: 3rem;
  text-transform: uppercase;
}

select option {
  color: black;
}

label.weight {
  color: #c87831;
  font-size: 1.5rem;
  margin-left: -1rem;
}

.contact {
  width: calc(90% - 4rem);
  max-width: 600px;
  margin: auto;
  padding: 0.5rem 2rem;
  margin-top: 3rem;
  line-height: 3rem;
  background: black;
  border-radius: 30px;
  color: #d9a86b;
  font-size: 1.5rem;
}

.contact:hover {
  background-color: rgba(0, 0, 0, 0.95);
  box-shadow: 4px 4px 4px 0px rgba(50, 50, 50, 0.5);
  transition: background-color 0.1s ease-in-out;
}

a.contact {
  text-decoration: none;
}

.contact .title {
  flex: 1;
  font-size: 1rem;
}

.contact .number {
  flex: 1;
  font-size: 1.8rem;
  text-align: right;
  white-space: nowrap;
}

.contact .number img {
  height: 2.5rem;
  vertical-align: middle;
}

@media screen and (orientation: landscape) and (max-height: 440px) {
  .table-header {
    line-height: 4rem;
  }

  .table-header .col-price {
    line-height: 2rem;
  }

  .table-header select {
    height: 1.5rem;
  }

  .table-body .row {
    line-height: 2rem;
    border-radius: 10px;
    margin-top: 1rem;
  }

  .table-body .col-metal div {
    display: inline;
    white-space: nowrap;
  }

  .table-body .col-metal .change {
    margin-top: 0;
    padding-right: 0;
  }

  .contact {
    line-height: 1.5rem;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }

  .contact .title {

  }

  .contact .number {
  font-size: 1.2rem;
  text-align: right;
  white-space: nowrap;
  }

  .contact .number img {
    height: 1.5rem;
    vertical-align: middle;
  }
}

@media screen and (orientation: portrait) and (max-width: 380px) {
  .table-body .row {
    line-height: 3.1rem;
    margin-top: 1.5rem;
  }

  .contact .label {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PriceTable.vue